import { Box, Button, Grid, styled, Typography } from "@mui/material";
import { leaveTypeBar, LeaveTypeBar } from "../../../const";
import pxToRem from "theme/base/pxToRem";
import { DatePicker } from "@mui/x-date-pickers";

export const ButtonActionCalendar = styled(Button)(({ theme }) => ({
  width: "100%",
  height: "32px",
  backgroundColor: theme.palette.background.bgTertiary,
  color: theme.palette.text.textPrimary,
  border: `1px solid ${theme.palette.stroke.strokeDefault}`,
  marginTop: "-0.625rem",
  fontWeight: 400,
  borderColor: "unset",

  transition: "background-color 0.3s ease-in-out",
  "&:disabled": {
    backgroundColor: "#E6E6E6", // Example disabled background
    color: "#B3B3B3", // Example disabled text color
    cursor: "not-allowed", // Ensure proper cursor for disabled state
  },
}));

export const DialogContentCustom = styled(Box)(({ theme }) => ({}));

export const TitleStyle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.size.sm_14,
  fontWeight: theme.typography.fw_regular_400,
  color: theme.palette.text.textPrimary,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "3px",
}));

export const TypeLeaveBar = styled(Box)<{ leaveType: LeaveTypeBar }>(
  ({ theme, leaveType }) => ({
    width: pxToRem(3),
    height: pxToRem(14),
    borderRadius: pxToRem(4),
    background: leaveTypeBar[leaveType],
  })
);
export const LabelDetail = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.size.sm_14,
  fontWeight: theme.typography.fw_regular_400,
  color: theme.palette.text.textSecondary,
}));

export const BoxSelectContainer = styled(Grid)(({ theme }) => ({
  padding: pxToRem(16),
  borderRadius: pxToRem(4),
  border: `1px solid ${theme.palette.stroke.strokeDefault}`,
  display: "flex",
  alignItems: "center",
  gap: pxToRem(12),
}));

export const Label = styled(Typography)(({ theme }) => ({
  fontSize: `${theme.typography.size.sm_14}`,
  lineHeight: theme.typography.lineHeight.sm,
  fontWeight: theme.typography.fw_regular_400,
  color: theme.palette.text.textPrimary,
}));

export const Wall = styled("div")(({ theme }) => ({
  height: pxToRem(30),
  width: pxToRem(1),
  backgroundColor: theme.palette.stroke.strokeDefault,
  marginRight: pxToRem(10),
}));

export const GridItem = styled(Grid)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: pxToRem(12),
  backgroundColor: theme.palette.background.bgTertiary,
  borderRadius: pxToRem(8),
  padding: `${pxToRem(8)} !important`,
}));

export const DatePickerCustom = styled(DatePicker)(({ theme }) => ({
  width: "100%",
  border: "none",
  height: "20px",
  "& .MuiInputBase-root": {
    height: "20px",
    border: "none",
    fontSize: "14px",

    "& input": {
      padding: "0px",
    },

    "& fieldset": {
      border: "none",
    },
  },
}));
